<script lang="ts">
import { useI18n } from '@src/composables/useI18n'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SearchTip',
  setup() {
    const { t } = useI18n()
    return { t }
  }
})
</script>

<template>
  <div class="d-flex flex-column px-6">
    <span class="text-caption font-weight-medium text-secondary text-uppercase">
      {{ t('autocomplete.tip') }}
    </span>
    <div class="d-flex py-3">
      <v-icon
        class="mr-2 text-secondary"
      >
        ico-sm-stream-outline
      </v-icon>
      <span class="text-secondary text-body-2">{{ t('autocomplete.tip-content') }}</span>
    </div>
  </div>
</template>
